import router from '@/router';
import { createStore } from 'vuex'
// import user from './modules/user';

// 自动引入modules文件夹下的所有模块
// require.context 是webpack加的方法
// 路径 ,是否子目录, 读文件的标识
const autoImportModules = {};
const moduleFiles = require.context('./modules', true, /\.js$/);
// console.log(moduleFiles)
moduleFiles.keys()
  .forEach(filepath => {
    // console.log('每个路径', filepath);
    let moduleObj = moduleFiles(filepath);
    // 获取到不同的业务模块名称
    let reg = /.*\/(.*)\.js$/;
    let moduleName = reg.exec(filepath)[1];
    autoImportModules[moduleName] = moduleObj.default;
  });

export default createStore({
  state: {     //数据
  },
  getters: {   //获取方式
  },
  mutations: { //变更
  },
  actions: {   //异步业务
  },
  modules: autoImportModules
});